<template>
    <div class="d-flex flex-column wrapper-ai" v-if="thread"  :class="{'on-response': fullSizeView, 'on-loading': onLoading, 'on-need-action': needAction}">
        <div class="d-flex container-ai overflow-hidden" style="flex: 1;">
            <div :class="['modal-backdrop', {'show' : showChatOnMobile}]" @click="showChatOnMobile = !showChatOnMobile"></div>
            <div class="d-flex flex-column col-chat w-100">
                <div class="list-prompts" :class="{'active': showChatOnMobile}" v-show="thread.prompts && thread.prompts.length">
                    <button class="ml-auto btn btn-link btn-chiudi-chat text-secondary mb-lg-2" @click="showChatOnMobile = !showChatOnMobile">
                        <i class="fas fa-times"></i>
                    </button>
                    <div class="scroller-content">
                        <template v-if="thread.prompts && thread.prompts.length">
                            <template v-for="(prompt, index) in thread.prompts">
                                <div v-if="!prompt.preventVisibility" class="mb-3" :key="index + '-list-prompts'">
                                    <div class="prompt text-nowrap justify-content-end align-items-center d-flex flex-row" :class="{'active': index == thread.prompts.length -1 || index == currentIndex, 'system': prompt.system}" :data-index="index">
                                        <span class="mr-1 edit-prompt-container" role="button" @click.stop="editPrompt($event, prompt)" v-show="!prompt.onEdit && !prompt.blockEdit" v-if="index == thread.prompts.length - 1">
                                            <i class="fas fa-pencil-alt"></i>
                                        </span>
                                        <span class="box-text text-wrap" v-if="!prompt.onEdit">
                                            <span v-html="$options.filters.labelPrompt(prompt)"></span>
                                        </span>
                                        <span class="w-100" v-else>
                                            <div class="form-group">
                                                <input v-model="prompt.prompt" type="text" class="form-control" @keyup.enter="confermaEditPrompt(prompt)">
                                            </div>
                                            <div class="d-flex justify-content-between">
                                                <button class="btn btn-link btn-sm" role="button" @click.stop="prompt.onEdit = false">
                                                    Annulla
                                                </button>
                                                <button class="btn btn-outline-primary btn-sm" :disabled="!prompt.prompt" role="button" @click.stop="confermaEditPrompt(prompt)">
                                                    <i class="fas fa-check"></i> Aggiorna
                                                </button>
                                            </div>
                                        </span>
                                    </div>

                                    <div class="response" v-if="prompt.response && !(prompt.system && prompt.audio)">
                                        <div class="d-flex align-items-start">
                                            <span>
                                                <img src="/assets/ai/idoctors-sofia-icon-modern-flat-tre-stelle.png" class="img-fluid rounded-circle mr-1" alt="AI">
                                            </span>
                                            <span class="box-text">
                                                <span v-if="prompt.response.aiResponse.text.textFaild" v-html="prompt.response.aiResponse.text.textFaild"></span>
                                                <span v-else v-html="prompt.response.aiResponse.text.testo"></span>
                                                <span v-if="needAction">
                                                    <span v-if="needAction == 'location' && index == thread.prompts.length -1">
                                                        <button type="button" @click="requestGeoLocation()" class="btn btn-outline-primary btn-xs">Trova la mia posizione</button>
                                                    </span>
                                                </span>
                                                <span class="wrapper-suggestions" v-if="!needAction && suggestions && suggestions.length && index == thread.prompts.length -1">
                                                    Migliora la tua ricerca: 
                                                    <span class="suggestions-group" v-for="(gruppo, iGruppo) in suggestions" :key="iGruppo + 'list-group-sug'">
                                                        <span v-if="gruppo.list.length" class="suggestions">
                                                            <!-- <span v-if="gruppo.role == 'specializzazione'">
                                                                Specializzazi:
                                                            </span>
                                                            <span v-if="gruppo.role == 'patologia'">
                                                                Patologie:
                                                            </span>
                                                            <span v-if="gruppo.role == 'patologia'">
                                                                Patologie:
                                                            </span>
                                                            <span v-if="gruppo.role == 'prestazione'">
                                                                Prestazioni:
                                                            </span>
                                                            <span v-if="gruppo.role == 'location'">
                                                                Filtra per città:
                                                            </span> -->
                                                            <span @click="selectSuggetion(suggestion)" class="suggestion badge badge-light" v-for="(suggestion, index) in gruppo.list" :key="index + '-suggestions'">{{ suggestion | suggestionLabel }}</span>
                                                            <span v-if="gruppo.role == 'location'">
                                                                <span type="button" @click="requestGeoLocation(true)" class="suggestion badge badge-primary">Vicino a me</span>
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>    
                                            </span>
                                        </div>                                    
                                        <div class="text-left" v-if="!onLoading">
                                            <span class="flex-row feedback-button-wrapper justify-content-start" v-if="index == thread.prompts.length - 1">
                                                <span class="button border-lighth" role="button" @click.stop="feedbackPrompt(prompt, 1)">
                                                    <i class="fa-thumbs-up" role="button" :class="[prompt.response.feedback == 1 ? 'fas feedbackgave' : 'far']"></i>
                                                </span>
                                                <span class="button border-lighth" role="button" @click.stop="feedbackPrompt(prompt, -1)">
                                                    <i class="fa-thumbs-down" :class="[prompt.response.feedback == -1 ? 'fas feedbackgave' : 'far']"></i>
                                                </span>
                                                <span class="button border-lighth" role="button" @click.stop="requestThread(prompt, true)">
                                                    <i v-if="prompt.response" class="fas fa-sync-alt"></i>
                                                </span>
                                                <span class="button border-lighth" role="button" @click.stop="deletePrompt(prompt)" v-if="index > 0">
                                                    <i class="fas fa-trash-alt"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <div class="response" v-if="onLoading">
                                <div class="d-flex align-items-start">
                                    <span>
                                        <img src="/assets/ai/idoctors-sofia-icon-modern-flat-tre-stelle.png" class="img-fluid rounded-circle mr-1" alt="AI">
                                    </span>
                                    <span class="box-text">
                                        <div class="loading-container">
                                            <div class="dots">
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                                <div class="dot"></div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>                    
                        </template>
                    </div>
                </div>

                <div class="chat-input-wrapper">
                    <h2 class="text-center" v-if="!thread.prompts || !thread.prompts.length">Di cosa hai bisogno?</h2>
                    <div class="wrapper-input bg-gray-200 d-flex flex-column" :class="{'mt-auto': fullSizeView}">
                        <div class="d-flex flex-column flex-1">
                            <div class="d-flex mb-1 justify-content-between align-items-center">
                                <div class="w-100 mr-2 wrapper-filters" v-if="argomentiDiRicerca && !needAction">
                                    <template v-for="(a, k) in argomentiDiRicerca">
                                        <span :key="'list-args' + k" class="wrapper-argomento" v-if="a && a.list && a.list.length">
                                            <!-- <span>
                                                {{ a.key }}
                                            </span> -->
                                            <span role="button" @click="removeFilter(filter)" class="badge badge-outline-secondary m-1" v-for="(filter, index) in a.list" :key="index + '-filters-arg' + k">
                                                <span>{{ (filter['key'] ? filter['key'] + ' ' : '') + filter['value'] }} <i class="fas fa-times"></i></span>
                                            </span>
                                        </span>
                                    </template>
                                </div>
                                <div class="ml-auto show-chat" v-if="fullSizeView">
                                    <button class="btn btn-outline-primary" @click="showChatOnMobile = !showChatOnMobile">
                                        <i class="fas fa-comments"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div @click="focusInput($event)" class="input-box bg-white mx-auto d-flex jusityf-content-between w-100">
                                <input ref="input" :disabled="onLoading" v-model="prompt" :placeholder="placeHolderInput" v-on:keyup.enter="requestThread()" @click.stop="1" type="text">
                                <div class="button-wrapper">
                                    <button class="btn btn-outline-primary btn-record-audio" @click.stop v-show="!prompt" :disabled="onLoading" :data-id-thread="idThread" @click.stop role="button">
                                        <i class="fas fa-microphone"></i>
                                    </button>
                                    <button class="btn btn-outline-primary" v-show="prompt" :disabled="!prompt" @click.stop="requestThread()" role="button">
                                        <i class="fas fa-paper-plane"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        
                        <small class="info-ai text-center mt-3">
                            {{ infoAi }}
                        </small>
                    </div>
                    <template v-if="!thread || !thread.prompts.length">
                        <div class="suggestions-group mt-3 mb-1 text-center" v-for="(gruppo, iGruppo) in suggestions" :key="iGruppo + 'list-group-sug'">
                            <div v-if="gruppo.list.length" class="suggestions">
                                <span role="button" @click="selectSuggetion(suggestion)" class="suggestion badge badge-light rfs-6 mr-2 mt-2" v-for="(suggestion, index) in gruppo.list" :key="index + '-suggestions'">{{ suggestion | suggestionLabel }}</span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div :class="['col-response', {'underback': showChatOnMobile}]" v-if="fullSizeView">
                <div class="last-response-ai bg-gray-200 shadow" v-if="currentPrompt && currentPrompt.response">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex align-items-center">
                                    <span class="align-self-start">
                                        <img src="/assets/ai/idoctors-sofia-icon-modern-flat-tre-stelle.png" class="img-fluid rounded-circle mr-1" alt="AI">
                                    </span>
                                    <span class="box-text">
                                        <span v-if="currentPrompt.response.aiResponse.text.textFaild" v-html="currentPrompt.response.aiResponse.text.textFaild"></span>
                                        <span v-else v-html="currentPrompt.response.aiResponse.text.testo"></span>
                                        <span v-if="fullSizeView && !needAction && suggestions && suggestions.length">
                                            <a class="btn-link" @click="showChatOnMobile = !showChatOnMobile">
                                                Migliora la tua ricerca
                                            </a>
                                        </span>
                                    </span>
                                    <button class="btn btn-link ml-auto" data-toggle="modal" data-target="#modalInfoAi">
                                        <i class="fas fa-info-circle"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="need-action-wrapper text-center d-flex justify-content-center p-5 align-items-center flex-column h-100" v-if="needAction">
                    <template v-if="needAction == 'onError'">
                        <h4 class="text-danger">
                            <i class="fas fa-exclamation-triangle"></i> Ops! 
                        </h4>
                        <p>
                            Si è verificato un errore!
                        </p>
                        <div class="d-flex mt-3 justify-content-between w-100">
                            <a href="/contatti" class="btn btn-outline-primary">
                                <i class="fas fa-envelope"></i> Contattaci
                            </a>
                            <button type="button" @click="requestThread(null, true)" class="btn btn-primary">
                                <i class="fas fa-sync-alt"></i> Riprova
                            </button>
                        </div>
                    </template>
                    <template v-if="needAction == 'location'">
                        <h4>
                            Richiesta di geolocalizzazione
                        </h4>
                        <p>{{ currentPrompt.response.aiResponse.text.textFaild ? currentPrompt.response.aiResponse.text.textFaild :  currentPrompt.response.aiResponse.text.testo }}</p>
                        <button type="button" @click="requestGeoLocation()" class="btn btn-primary">Trova la mia posizione</button>
                    </template>
                    <template v-if="needAction == 'mainTopic'">
                        <h4>
                            Completa la tua ricerca
                        </h4>
                        <p>
                            Sono un sistema di ricerca basato su AI. Cerca una specializzazione o una patologia per iniziare a trovare lo specialista di cui hai bisogno
                        </p>
                        <div class="suggestions-group" v-for="(gruppo, iGruppo) in suggestions" :key="iGruppo + 'list-group-sug'">
                            <div v-if="gruppo.list.length" class="suggestions">
                                <span rolw="button" @click="selectSuggetion(suggestion)" class="btn m-2 suggestion badge badge-light" v-for="(suggestion, index) in gruppo.list" :key="index + '-suggestions'">{{ suggestion | suggestionLabel }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-if="needAction == 'checkParams'">
                        <h4>
                            <i class="fas fa-info-circle"></i> Verifica la tua richiesta
                        </h4>
                        <p>
                            <b>Non</b> è stato possibile trovare uno specialista con i parametri inseriti. Verifica i parametri inseriti e riprova, eventualmente rimuovi i filtri di ricerca.
                        </p>
                        <div class="w-100" v-if="argomentiDiRicerca">
                            <template v-for="(a, k) in argomentiDiRicerca">
                                <div class="wrapper-argomento border-bottom text-left mb-2" :key="'need-action-list-args' + k" v-if="a && a.list && a.list.length">
                                    <span>
                                        {{ a.key }}
                                    </span>
                                    <span role="button" @click="removeFilter(filter)" class="badge badge-primary m-1" v-for="(filter, index) in a.list" :key="index + 'need-action-filters-arg' + k">
                                        <span>{{ (filter['key'] ? filter['key'] + ' ' : '') + filter['value'] }} <i class="fas fa-times"></i></span>
                                    </span>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="skeleton-container" v-if="onLoading">
                                <skeleton v-for="k in Array.from({ length: 100 }, (_, i) => i)" :key="k"></skeleton>
                            </div>
                            <div v-for="(response, index) in responses" :key="index + '-response'" class="mb-3" :class="response.target + '-response'">
                                <template v-if="response.medici">
                                    <template v-for="(medico, k) in response.medici">
                                        <div class="alert table-secondary text-center" v-if="medico.firstAltraCitta && listCitta && listCitta.length">
                                            <i class="fas fa-info-circle"></i> 
                                            <template v-if="k == 0">
                                                Specialisti nelle vicinanze di <b>{{ listCitta[0].nome }}</b>
                                            </template>
                                            <template v-else>
                                                Altri specialisti vicino a <b>{{ listCitta[0].nome }}</b>
                                            </template>
                                        </div>
                                        <div :key="k + '-medico'">
                                            <card-medico-a-i :medico="medico"></card-medico-a-i>
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="response.html">
                                    <div v-html="response.html"></div>
                                </template>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalInfoAi">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-info-circle"></i> Informazioni
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" ref="bodyModal">
                        <div class="row">
                            <div class="col">
                                <p class="mb-0" v-html="infoAi"></p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Chiudi
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>            

<script>
import CardMedicoAI from './CardMedicoAI.vue';
import Skeleton from './Skeleton.vue';

export default {
    components: { Skeleton, CardMedicoAI },
    props: {
        id: null
    },
    data: function() {
        return {
            onReady: false,
            idThread: null,
            prompt: null,
            fullSizeView: false,
            needAction: false,
            currentIndex: null,
            onLoading: false,
            showChatOnMobile: false,
            thread: null,
            responses: [],
            suggestions: [],
            listCitta: null,
            argomentiDiRicerca: null,
            placeHolderInput: '',
            timerPLaceholder: null,
            infoAi: 'Questo è uno strumento di ricerca che utilizza l’Intelligenza Artificiale e potrebbe commettere errori. Considera di verificare le informazioni importanti.',
        };
    },
    computed: {
        currentPrompt: function() {
            let index = this.thread.prompts.length - 1;
            if (this.currentIndex) {
                index = this.currentIndex;
            }
            return this.thread.prompts[index] || null;
        }
    },
    watch: {
        onLoading: function(val) {
            if (this.timerPLaceholder) {
                clearTimeout(this.timerPLaceholder);
            }
            if (! val) {
                return this.placeHolderInput = 'Digita ciò di cui hai bisogno...';
            }

            this.placeHolderInput = 'Attendi sto elaborando';
            const dots = ['.', '..', '...', '....'];

            let i = 0;
            this.timerPLaceholder = setInterval(() => {
                if (i >= dots.length) {
                    i = 0;
                }
                this.placeHolderInput = 'Attendi sto elaborando' + dots[i];
                i++;
            }, 500);
        },
        fullSizeView: function(val) {
            $('body').removeClass('thread-shown thread-not-shown');
            $('html').removeClass('overflow-hidden');

            if (val) {
                $('body').addClass('thread-shown');
                $('html').addClass('overflow-hidden');
                return;
            }

            $('body').addClass('thread-not-shown');
        }
    },
    async mounted() {
        this.idThread = this.id != '0' ? this.id : null;
        if (this.id != '0') {
            this.fullSizeView = true;
            this.thread = {
                prompts: [
                    {
                        prompt: 'Cerca uno specialista e prenota....',
                        system: true,
                        preventVisibility: true
                    }
                ]
            };
        }
        await this.requestThread();
        //listen for resize event
        $(window).on('resize', () => {
            //get the element .col-chat height
            let height = $('.col-chat').height();
            //apply to :root--chatheight
            document.documentElement.style.setProperty('--chatheight', height + 'px');
        });
    },
    methods: {
        removeFilter: async function(filter) {
            question('Confermi di voler cancellare "<b>' + filter.key + ' ' + filter.value + '<b>?', async (ask) => {
                if (ask) {
                    let promptLabel = null;

                    switch (filter.scope) {
                        case 'vicino_a_me':
                            promptLabel = 'Rimuovi la geolocalizzazione';
                            break;
                        case 'ordinamento':
                            promptLabel = 'Rimuovi l\'ordinamento per ' + filter.value;
                            break;
                        case 'paginazione':
                            promptLabel = 'Rimuovi il limite di ' + filter.value + ' risultati';
                            break;
                        case 'specializzazioni':
                            promptLabel = 'Rimuovi la specializzazione ' + filter.value;
                            break;
                        case 'patologie':
                            promptLabel = 'Rimuovi la patologia ' + filter.value;
                            break;
                        case 'prestazioni':
                            promptLabel = 'Rimuovi la prestazione ' + filter.value;
                            break;
                        case 'citta':
                            promptLabel = 'Rimuovi la città ' + filter.value;
                            break;
                        case 'zone':
                            promptLabel = 'Rimuovi la zona ' + filter.value;
                            break;
                        default:
                            promptLabel = 'Rimuovi il filtro ' + filter.key + ' ' + filter.value;
                            break;
                    }

                    this.prompt = {
                        prompt: promptLabel,
                        filterKey: filter.key,
                        filterValue: filter.value,
                        removeFilter: filter,
                        system: true,
                        blockEdit: true
                    };

                    await this.requestThread();
                }
            });
            
        },
        confermaEditPrompt: async function (prompt) {
            prompt.onEdit = false;
            await this.requestThread(prompt);
        },
        annullaEditPrompt: function (prompt) {
            prompt.onEdit = false;
        },
        editPrompt: async function (ev, prompt) {
            Vue.set(prompt, 'onEdit', true);
            this.$nextTick(() => {
                $(ev.target).closest('.prompt').find('input').focus();
            });
        },
        requestGeoLocation: async function (cercaVicinoAme) {
            try {
                let coord = await window.requestLocation();
                this.prompt = {
                    prompt: 'Vicino a me',
                    blockEdit: true,
                    cercaVicinoAme: cercaVicinoAme ? 1 : 0,
                    location: {
                        latitudine: coord.coords.latitude,
                        longitudine: coord.coords.longitude
                    },
                    system: true,
                };

                await this.requestThread();
            } catch (error) {
                showError(error);
            }
        },
        feedbackPrompt: async function (prompt, feedback) {
            Vue.set(prompt.response, 'feedback', feedback);
            await httpRequest(api_url + 'frontend/aiListe/' + this.idThread + '/feedbackPrompt', {index: this.thread.prompts.indexOf(prompt), feedback: feedback});
        },
        deletePrompt: async function (prompt) {
            const index = this.thread.prompts.indexOf(prompt);
            if (index < 0) {
                return;
            }
            question('Confermi di voler cancellare la richiesta "<b>' + prompt.prompt + '<b>?', async (ask) => {
                if (ask) {
                    await httpRequest(api_url + 'frontend/aiListe/' + this.idThread + '/deletePrompt', {index: index});

                    this.thread.prompts.splice(index, 1);
                    this.requestThread();
                }
            });
        },
        focusInput: function(event) {
        
            event.target.querySelector('input').focus();
        },
        selectSuggetion: async function(suggestion) {
            let newSuggestion = {
                prompt: suggestion,
                suggestion: 1,
            };
            if (typeof suggestion == 'object') {
                newSuggestion.prompt = suggestion.label;
                newSuggestion.entity = suggestion;
            }
            this.prompt = newSuggestion;
            await this.requestThread();
        },
        resetDefaultParams: async function() {
            this.responses = [];
            this.suggestions = [];
            this.showChatOnMobile = false;
            this.needAction = false;
            this.currentIndex = null;
        },
        requestThread: async function(prompt, refresh = false) {

            this.resetDefaultParams();

            //se prompt viene passaito sono in aggiornamento, o refresh quindi non va fatto un push
            if (this.prompt && this.thread && !prompt) {
                let pushPrompt = null;
                if (typeof this.prompt == 'string') {
                    pushPrompt = {prompt: this.prompt};
                } else {
                    pushPrompt = this.prompt;
                }
                this.fullSizeView = true;
                this.thread.prompts.push(pushPrompt);
                this.$nextTick(() => {
                    let offset = $('.list-prompts .scroller-content > div:last').offset();
                    if (offset) {
                        $('.list-prompts .scroller-content').animate({scrollTop: offset.top}, 400);
                    }
                });
            }
            
            this.onLoading = true;
            
            if (prompt) {
                //distingue il caso in cui aggiorno il prompt, oppure lo sto solo rivalutando
                this.prompt = refresh ? null : prompt.prompt;
                this.currentIndex = this.thread.prompts.indexOf(prompt);
                if (this.currentIndex == -1) {
                    this.currentIndex = null;
                }
                this.thread.prompts[this.currentIndex].response = null
            }
            const postData = {
                prompt: this.prompt,
                refresh: refresh ? 1 : 0,
                toIndex: this.currentIndex
            };

            this.prompt = null;
            this.argomentiDiRicerca = null;
            
            let onResult = null;
            try {
                onResult = await httpRequest(api_url + 'frontend/aiListe' + (this.idThread ? '/' + this.idThread : ''), postData, {showLoader: this.thread ? false : true});    
            } catch (error) {
                this.needAction = 'onError';
            }
            

            this.onLoading = false;
            if (onResult) {
                if (! this.idThread && onResult.data.thread._id) {
                    this.idThread = onResult.data.thread._id;
                    if(typeof URL === 'function') {
                        const url = new URL(window.location.href);
                        url.pathname += '/' + onResult.data.thread._id;
                        window.history.pushState({}, '', url);
                    }
                }
                this.needAction = onResult.data.needAction;
                this.thread = onResult.data.thread;
                this.suggestions = onResult.data.suggestions;
                if (onResult.data.htmlPatologie) {
                    this.responses.push({
                        target: 'patologie',
                        //textResponse: 'A proposito di...',
                        textResponse: '',
                        html: onResult.data.htmlPatologie
                    });
                }

                this.listCitta = onResult.data.listCitta;

                if (onResult.data.medici) {
                    let last_altra_citta = false;
                    let showAltraCittaInfo = onResult.data.listCitta && onResult.data.listCitta.length == 1;
                    for (const m of onResult.data.medici) {
                        if (m.altra_citta && !last_altra_citta && showAltraCittaInfo) {
                            last_altra_citta = true;
                            m.firstAltraCitta = true;
                        }

                        let studi = m.studi;
                        for (const k in studi) {
                            let studio = studi[k];
                            let studioName = 'Studio ' + (m.tipoStudioCount > 1 ? parseInt(k) + 1 : '');
                            switch (studio.tipo) {
                                case 2:
                                    studioName = 'Domicilio'
                                    break;
                                case 3:
                                    studioName = studio.prestazioni[0].prestazione.nome.replace('Videoconsulto', '');
                                    break;
                            }
                            if (k == 0) {
                                studio.active = true;
                            }
                            studio.name = studioName;
                        }
                    }
                    this.responses.push({
                        target: 'medici',
                        textResponse: '',
                        medici: onResult.data.medici,
                    });
                }

                this.argomentiDiRicerca = onResult.data.argomentiDiRicerca;
            }
            
            

            this.fullSizeView = this.thread.prompts.length;

            

            this.$nextTick(() => {
                if (!this.onReady) {
                    setupRecorder(() => {
                        this.resetDefaultParams();
                        this.onLoading = true;
                        this.thread.prompts.push({
                            blockEdit: true,
                            prompt: '<i class="fas fa-spinner fa-spin"></i> Attendi sto elaborando...',
                        });
                    }, () => {
                        this.requestThread();
                    }, $(this.$el).find('.btn-record-audio'));

                    this.onReady = true;
                }
                $(window).trigger('resize');
                window.initListeJquery();
                //scroll to last prompt
                let offset = $('.list-prompts .scroller-content > div:last').offset();
                if (offset) {
                    $('.list-prompts .scroller-content').animate({scrollTop: offset.top}, 400);
                }
                
                $('.col-response').animate({scrollTop: 0}, 400);
            });
       }
    },
    filters: {
        labelPrompt: function (value) {
            let label = value.prompt;
            if (value.location) {
                label = 'Aggiunte coordinate geografiche';
            } else if (value.removeFilter) {
                label = 'Rimosso ' + (value.removeFilter.key ? value.removeFilter.key  : '') + ' ' + (value.removeFilter.value ? value.removeFilter.value : '');
            }

            return label;
        },
    },
}; 
</script>

<style>
    :root {
        --chatheight: 110px;
    }
</style>
<style lang="scss" scoped>
    .background-texture {
        background-image: url('/assets/tile-chiara-001.png'); 
        background-size: 250px;
        background-repeat: repeat;
    }
    .text-muted {
        color: #6c757d;
    }
    .scroller {
        &::-webkit-scrollbar {
            width: 6px;
        }
        &::-webkit-scrollbar-track {
            background: #dee2e6;
        }
        &::-webkit-scrollbar-thumb {
            background: var(--primary);
        }
    }
    .wrapper-ai {
        width: 100%;
        max-width: 1500px;
        overflow: hidden;
        margin: 0 auto;
        .container-ai {
            justify-content: space-between;
        }
        &:not(.on-response) {
            margin-top: auto;
            margin-bottom: auto;
            .wrapper-input {
                margin: auto;
                border-bottom-left-radius: 20px;
                border-bottom-right-radius: 20px;
                box-shadow: unset !important;
            }
        }

        &.on-loading, &.on-need-action {
            .col-response {
                overflow: hidden;
            }
        }

        &.on-response {
            flex: 1;
            border: 1px solid #eee;
            .col-chat, .list-prompts  {
                @extend .background-texture;
            }
            .wrapper-input {
                flex-direction: column-reverse;
                .wrapper-filters {
                    overflow-x: auto;
                    text-wrap: nowrap;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    &::-webkit-scrollbar {
                        display: none; /* Per Chrome, Safari e Edge */
                    }
                }
                .suggestions {
                    display: inline-block;
                    width: 100%;
                    overflow-y: hidden;
                    overflow-x: auto;
                    margin-bottom: 10px;
                    white-space: nowrap;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    &::-webkit-scrollbar {
                        display: none; /* Per Chrome, Safari e Edge */
                    }
                }
            }
        }
        .feedback-button-wrapper {
            margin-top: 10px;
            display: inline-flex;
            justify-content: flex-start;
            border-radius: 20px;
            background-color: #fff;
            padding: 0px 10px;
            .button {
                padding: 5px;
                @extend .text-muted;
                &:not(:last-child) {
                    margin-right: 15px;
                }

                &:hover {
                    color: #000;
                }

                .feedbackgave {
                    color: #066dbb;
                }
                
            }
        }
        .edit-prompt-container {
            i {
                color: #6c757d;
                &:hover {
                    color: #000;
                }
            }
        }
        .col-chat {
            flex: 1;
            width: 100%;
            overflow-y: hidden;
            font-size: 14px;
            z-index: 1000;

            .btn-chiudi-chat {
                display: none;
            }
            .show-chat {
                font-size: 14px;
                display: none;
            }
            .list-prompts {
                flex: 1;
                overflow-y: hidden;
                height: 100%;
                padding-bottom: 1rem;
                .scroller-content {
                    overflow-y: auto;
                    height: 100%;
                    padding-bottom: 10px;
                    padding: 0px 10px 10px;
                    @extend .scroller;
                }
                .box-text {
                    border-radius: 5px;
                    display: inline-block;
                    padding: 10px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }
                .prompt {
                    margin: 9px 0px;
                    text-align: right;
                    padding-left: 50px;
                    max-width: 600px;
                    margin-left: auto;
                    .box-text {
                        border: 1px solid transparent;
                        background-color: #eff8fe;
                    }
                    &.system {
                        padding-left: 0px;
                        text-align: center;
                        justify-content: center !important;
                        max-width: 100%;
                        .box-text {
                            background-color: #fff;
                            box-shadow: unset;
                            font-style: italic;
                            font-size: 13px;
                            @extend .text-muted;
                        }
                    }
                }

                .wrapper-suggestions {
                    display: block;
                    flex-direction: column;
                    border-radius: 20px;
                    background-color: #fff;
                    margin-top: 10px;
                    .suggestions {
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: flex-start;
                        align-items: center;
                        margin-top: 10px;
                        .suggestion {
                            padding: 5px 10px;
                            margin: 5px;
                            border-radius: 20px;
                            cursor: pointer;
                        }
                    }
                }

                .response {
                    margin: 9px 0px;
                    text-align: left;
                    padding-right: 50px;
                    max-width: 600px;
                    img {
                        max-width: 35px;
                        max-height: 35px;
                    }
                    .box-text {
                        border: 1px solid #eee;
                        background-color: white;
                        position: relative;
                        margin-left: 14px;
                        &::after {
                            content: " ";
                            position: absolute;
                            width: 0;
                            height: 0;
                            left: -12px;
                            right: auto;
                            top: 10px;
                            bottom: auto;
                            border-color: transparent #fff;
                            border-style: solid;
                            border-width: 8px 12px 8px 0;
                        }
                    }
                }
            }

            .chat-input-wrapper {
                padding: 0px 10px;
    
                @media (max-width: 1150px) {
                    padding: 0;
                }
            }

            .wrapper-input {
                flex-direction: column;
                padding: 10px;
                max-width: 700px;
                width: 100%;
                margin: 0 auto;

                @media (min-width: 1150px) {
                    border-top-left-radius: 20px;
                    border-top-right-radius: 20px;
                    border: 1px solid #eee;
                }

                @media (max-width: 1150px) {
                    border-radius: 0;
                    position:sticky;
                    bottom:0;
                    z-index:1001;
                }
                
                small.info-ai {
                    display: block;
                }
                h2 {
                    text-align: center;
                }
                .input-box {
                    border: 1px solid #eee;
                    width: 100%;
                    padding: 10px;
                    border-radius: 20px;
                    cursor: text;

                    @media (max-width: 1150px) {
                        padding: 2px 5px;
                    }

                    .button-wrapper  {
                        display: flex;
                        flex-direction: row;
                        margin-top: auto;
                        margin-bottom: auto;

                        .btn {
                            margin-left: 5px;
                            border-radius: 50%;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border: 1px solid;
                            width: 30px;
                            height: 30px;
                            position: relative;
                            i {
                                position: absolute;
                            }
                        }
                    }
                    input {
                        display: block;
                        width: 100%;
                        height: calc(1.5em + 0.75rem + 2px);
                        padding: 0.375rem 0.75rem;
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 1.5;
                        color: #495057;
                        background-color: transparent;
                        background-clip: padding-box;
                        border: unset;
                        border-radius: 0;
                        outline: none;
                        box-shadow: none;
                    }
                }
            }
        }

        .col-response {
            flex: 1;
            width: 100%;
            padding: 10px 0px;
            max-width: 750px;
            min-width: 750px;
            overflow-y: auto;
            border-left: 1px solid #eee;
            @extend .scroller;  
            .last-response-ai {
                display: none;
                padding-bottom: 10px;
                border-bottom:1px solid #ccc;
                img {
                    max-width: 35px;
                    max-height: 35px;
                }
                .box-text {
                    position: relative;
                    margin-left: 5px;
                    font-family:'Courier New', Courier, monospace;
                    font-size: 14px;
                }
            }     
        }

        .loading-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            padding: 5px 0px;
            .dots {
                display: flex;
                gap: 8px;

                .dot {
                    width: 8px;
                    height: 8px;
                    background-color: #066dbb;
                    border-radius: 50%;
                    animation: pulse 1.5s infinite ease-in-out;
                }

                .dot:nth-child(1) { animation-delay: 0s; }
                .dot:nth-child(2) { animation-delay: 0.2s; }
                .dot:nth-child(3) { animation-delay: 0.4s; }
            }
        }
    }

    @media (max-width: 1150px) {
        .wrapper-ai {
            .container-ai {
                flex-direction: column-reverse;
                position: relative;
            }
            .col-response {
                padding-top: 0;

                min-width: 100%;
                max-width: 100%;
                border-bottom: 1px solid #eee;
                .last-response-ai {
                    display: block;

                    z-index: 999;
                    position: sticky;
                    top: 0;
                    left: 0;
                    padding-top: 10px;

                    .feedback-button-wrapper {
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    }
                }
            }
            .col-chat {
                @media (max-width: 1150px) {
                    box-shadow: 1px 0rem 0.25rem 1px rgba(0, 0, 0, 0.25) !important;
                    border-top:1px solid #ccc;
                }

                flex: unset;
                background-image: unset;
                .btn-chiudi-chat {
                    display: block;
                }
                .list-prompts {
                    
                    position: absolute;
                    bottom: -100%;
                    transition: bottom 0.3s, top 0.3s;
                    left: 10px;
                    right: 10px;
                    border: 1px solid #eee;
                    border-radius: 10px;
                    height: 100%;
                    padding: 10px;
                    background-color: #fff;
                    z-index: 1002;
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    max-height: calc(100vh - 68px - 170px);

                    &.active {
                        bottom: 153px;
                    }

                    @media (max-width: 1150px) {
                        max-height: calc(100vh - 150px);
                        max-height: calc(100dvh - 150px);
                        left: 60px;
                        right: 0px;
                        border:1px solid #ccc;
                        top: auto;
                        box-shadow: none;
                        border-radius: 0;
                        position: fixed;

                        &.active {
                            bottom: var(--chatheight);
                            transition: bottom 0.3s, top 0.3s;
                            margin-top: 0;
                        }
                    }
                }

                .show-chat {
                    display: flex;
                    flex-direction: row;
                    .btn {
                        font-size: 14px;
                        padding: 2px 7px;
                    }
                }

                .wrapper-input {
                    small.info-ai {
                        display: none;
                    }
                }
            }
        }
    }

    .wrapper-filters {
        .badge {
            font-size: .8rem;

            &:hover {
                background-color: #fff;
            }
        }
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100vw;
        height: 100vh;
        background-color: #000;
        opacity: 0;
        transition: opacity 0.3s;
        pointer-events: none;
        
        &.show {
            opacity: .5;
            pointer-events: all;
        }
    }

    .underback {
        z-index: 1;
    }
</style>